var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"clearable":false,"options":_vm.currencies,"placeholder":_vm.currency.label,"value":_vm.currency},on:{"input":_vm.setCurrency}})}
var staticRenderFns = []

export { render, staticRenderFns }